import React, { Fragment } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Card,
  CardContent,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'

interface SkuItem {
  sku: string
  name: string
  quantity: number
}

interface ListSkuComponentProps {
  skus: SkuItem[]
}

export const ListSkuComponent: React.FC<ListSkuComponentProps> = ({ skus }) => {
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  return (
    <Fragment>
      {isMobile ? (
        // Vista Card en dispositivos pequeños
        <div className={classes.cardContainer}>
          {skus.map((item, index) => (
            <Card key={index} className={classes.card}>
              <CardContent className={classes.cardContent}>
                <div>
                  <Typography className={classes.cardTitle}>
                    {item.sku}
                  </Typography>
                  <Typography>{item.name}</Typography>
                </div>
                <Typography color='primary'>{item.quantity}</Typography>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell
                  className={`${classes.tableCellLeft} ${classes.tableHeader}`}
                >
                  SKU
                </TableCell>
                <TableCell
                  className={`${classes.tableCellLeft} ${classes.tableHeader}`}
                >
                  Nombre
                </TableCell>
                <TableCell
                  className={`${classes.tableCellRight} ${classes.tableHeader}`}
                >
                  Cantidad
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {skus.map((item, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.tableCellLeft}>
                    {item.sku}
                  </TableCell>
                  <TableCell className={classes.tableCellLeft}>
                    {item.name}
                  </TableCell>
                  <TableCell className={classes.tableCellRight}>
                    {item.quantity}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Fragment>
  )
}

const useStyles = makeStyles((theme: Theme) => ({
  tableContainer: {
    maxWidth: '100%',
    overflowX: 'auto',
    maxHeight: 300
  },
  table: {
    minWidth: 300
  },
  tableCellLeft: {
    textAlign: 'left'
  },
  tableCellRight: {
    textAlign: 'right'
  },
  tableHeader: {
    fontWeight: 'bold',
    backgroundColor: theme.palette.grey[200]
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    maxHeight: 300,
    overflowY: 'auto',
    padding: theme.spacing(1)
  },
  card: {
    padding: theme.spacing(1.5),
    boxShadow: theme.shadows[3]
  },
  cardTitle: {
    fontWeight: 'bold'
  },
  cardContent: {
    display: 'flex',
    justifyContent: 'space-between'
  }
}))
